
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinchennai() {



    const cardData =
    {
        keyword: '  Corporate Cab Services in Chennai ',
        heading: 'etravo : Corporate Cab Services in Chennai',



"headingDescription": "eTravo offers reliable Corporate Cab Services in Chennai, designed for MNCs, IT companies, industrial units, and professionals who require seamless transportation for employee commuting, airport transfers, client meetings, and executive travel. With GPS-enabled vehicles, experienced chauffeurs, and flexible corporate plans, eTravo ensures safe, punctual, and comfortable mobility across Chennai and its major business and IT corridors.",

"top": "Top Corporate Cab Service Zones in Chennai with eTravo",

"topPlaces": [
  {
    "title": "OMR (Old Mahabalipuram Road)",
    "description": "Chennai’s primary IT corridor hosting major tech parks and MNC offices, requiring large-scale employee transport and shift-based cab services."
  },
  {
    "title": "Tidel Park (Taramani)",
    "description": "A key IT hub with high corporate density where daily office commute and shuttle services are widely used."
  },
  {
    "title": "Guindy Industrial Estate",
    "description": "A major industrial and commercial zone requiring structured employee transportation and business travel support."
  },
  {
    "title": "Siruseri SIPCOT IT Park",
    "description": "One of the largest IT parks in Chennai with thousands of employees requiring reliable corporate cab services."
  },
  {
    "title": "Velachery",
    "description": "A fast-growing residential and commercial hub supporting IT professionals commuting to OMR and nearby tech parks."
  },
  {
    "title": "Perungudi",
    "description": "A key IT corridor location with corporate offices requiring daily employee pickup and drop services."
  },
  {
    "title": "Guindy to Airport Corridor",
    "description": "A major corporate travel route connecting business hubs to Chennai International Airport for executive transfers."
  },
  {
    "title": "Anna Salai (Mount Road)",
    "description": "A central business district with corporate offices, banks, and commercial establishments requiring executive travel services."
  },
  {
    "title": "Ambattur Industrial Estate",
    "description": "A large industrial hub requiring workforce transportation and shift-based cab services."
  },
  {
    "title": "Porur & Ramapuram",
    "description": "Growing IT and commercial zones with increasing demand for corporate mobility and employee transport services."
  }
],


"services": [
{
"name": "Corporate Cab Chennai",
"description": "eTravo offers reliable corporate cab services in Chennai designed for smooth and professional business travel. Our service ensures punctual pickups, comfortable rides, and experienced chauffeurs for daily office commuting and executive travel."
},
{
"name": "Corporate Taxi Chennai",
"description": "Our corporate taxi services in Chennai provide efficient and flexible transportation for businesses. eTravo ensures timely service, clean vehicles, and a seamless travel experience for executives and employees."
},
{
"name": "Company Cab Service Chennai",
"description": "eTravo provides company cab services in Chennai tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport Chennai",
"description": "Simplify daily commuting with eTravo’s office transport services in Chennai. We offer structured and dependable transportation solutions for employees across major business areas."
},
{
"name": "Employee Cab Chennai",
"description": "Our employee cab services in Chennai are designed for safe and punctual workforce mobility. eTravo ensures well-planned routes and comfortable rides for daily commuting."
},
{
"name": "Corporate Travel Chennai",
"description": "eTravo offers complete corporate travel services in Chennai for both local and outstation needs. Our service ensures smooth and reliable travel for executives and business teams."
},
{
"name": "Business Cab Chennai",
"description": "eTravo’s business cab services in Chennai are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality, comfort, and professional travel experiences."
},
{
"name": "Staff Transport Chennai",
"description": "eTravo provides dependable staff transport services in Chennai for daily employee commuting. Our service ensures timely pickups, safe travel, and efficient coordination."
},
{
"name": "Corporate Fleet Chennai",
"description": "eTravo offers corporate fleet services in Chennai for businesses requiring multiple vehicles. Our fleet ensures consistent quality, proper maintenance, and smooth transportation operations."
},
{
"name": "Company Taxi Chennai",
"description": "Our company taxi services in Chennai provide flexible and convenient transport options for businesses. eTravo ensures reliable travel for employees, clients, and executives."
},
{
"name": "Corporate Pickup Drop Chennai",
"description": "eTravo provides corporate pickup and drop services in Chennai for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Business Travel Cab Chennai",
"description": "Our business travel cab services in Chennai are designed for professionals traveling for meetings and corporate activities. eTravo ensures smooth, reliable, and comfortable journeys."
},
{
"name": "Office Cab Booking Chennai",
"description": "eTravo offers easy office cab booking services in Chennai with reliable and timely transportation. Our service ensures hassle-free travel for employees and corporate teams."
},
{
"name": "Corporate Commute Chennai",
"description": "eTravo’s corporate commute services in Chennai provide structured and efficient employee transportation. Our service ensures smooth daily travel with reliable vehicles and drivers."
},
{
"name": "Professional Cab Service Chennai",
"description": "eTravo provides professional cab services in Chennai designed to meet corporate standards. With trained drivers and well-maintained vehicles, we ensure safe, comfortable, and reliable travel."
}
],
"tableData": [
["Corporate Cab Chennai", "Corporate Taxi Chennai"],
["Company Cab Service Chennai", "Office Transport Chennai"],
["Employee Cab Chennai", "Corporate Travel Chennai"],
["Business Cab Chennai", "Staff Transport Chennai"],
["Corporate Fleet Chennai", "Company Taxi Chennai"],
["Corporate Pickup Drop Chennai", "Business Travel Cab Chennai"],
["Office Cab Booking Chennai", "Corporate Commute Chennai"],
["Professional Cab Service Chennai", ""]
],



"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Services in Chennai",
      "WhyChoosedescription": "eTravo offers professional corporate cab services in Chennai, ensuring smooth and efficient transportation for employees, executives, and business clients across major hubs like OMR, Guindy, Tidel Park, and Ambattur."
    },
    {
      "WhyChooseheading": "End-to-End Corporate Mobility Solutions",
      "WhyChoosedescription": "Corporate cab services in Chennai include employee transport, airport transfers, executive travel, and long-term rentals, providing complete travel solutions for businesses. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "On-Time Employee Pickup and Drop Services",
      "WhyChoosedescription": "Structured routes and optimized scheduling ensure employees reach offices on time, reducing commute stress and improving productivity in Chennai’s busy traffic conditions. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Travel Needs",
      "WhyChoosedescription": "Corporate cab providers offer hatchbacks, sedans, SUVs, buses, and luxury vehicles suitable for daily commute, executive travel, and corporate events. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Safety Standards",
      "WhyChoosedescription": "Experienced drivers with training and verification ensure safe, secure, and comfortable travel for employees and executives."
    },
    {
      "WhyChooseheading": "Technology-Driven Fleet Management",
      "WhyChoosedescription": "Modern corporate cab services use GPS tracking, real-time monitoring, and automated systems for efficient and transparent employee transportation. :contentReference[oaicite:3]{index=3}"
    },
    {
      "WhyChooseheading": "Flexible Monthly and Contract-Based Plans",
      "WhyChoosedescription": "Companies can choose daily pickup-drop, monthly contracts, and customized corporate travel plans based on workforce needs and shift timings. :contentReference[oaicite:4]{index=4}"
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel Needs",
      "WhyChoosedescription": "Round-the-clock support ensures smooth coordination, emergency assistance, and uninterrupted corporate mobility for businesses across Chennai. :contentReference[oaicite:5]{index=5}"
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services in Chennai?',
            answer: 'Corporate cab services in Chennai provide organized transportation for employees, executives, and clients including daily office commute and business travel.',
        },
        {
            question: 'What services are included in corporate cab services?',
            answer: 'Services include employee transport, airport pickup and drop, executive travel, and outstation trips. :contentReference[oaicite:6]{index=6}',
        },
        {
            question: 'Do corporate cab services provide daily pickup and drop?',
            answer: 'Yes, services include structured daily pickup and drop with optimized routes and schedules for employees. :contentReference[oaicite:7]{index=7}',
        },
        {
            question: 'Are corporate cab services available 24/7 in Chennai?',
            answer: 'Yes, most providers operate round the clock to support business travel and shift-based operations. :contentReference[oaicite:8]{index=8}',
        },
        {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, buses, and luxury cars depending on corporate requirements. :contentReference[oaicite:9]{index=9}',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols ensuring secure travel. :contentReference[oaicite:10]{index=10}',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, companies can customize routes, schedules, and rental plans based on workforce requirements.',
        },
        {
            question: 'Do corporate cab services offer monthly contracts?',
            answer: 'Yes, companies can opt for monthly and long-term corporate transport contracts. :contentReference[oaicite:11]{index=11}',
        },
        {
            question: 'Do corporate cab services provide airport transfers?',
            answer: 'Yes, corporate cab services include airport pickup and drop for employees, executives, and business clients. :contentReference[oaicite:12]{index=12}',
        },
        {
            question: 'How can I book corporate cab services in Chennai?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Karthik Raman',
        designation: 'Operations Manager, IT Company, Chennai',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides excellent corporate cab services in Chennai. Their punctual pickups and professional drivers ensure smooth daily operations for our team.”',
    },
    {
        name: 'Ms. Priya Subramanian',
        designation: 'HR Manager, Corporate Firm, Chennai',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for employee transportation in Chennai. Their flexible plans and reliable service make commuting easy and stress-free for our employees.”',
    },
];




    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Chennai",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-chennai.jpg",
  "description": "Reliable corporate cab services in Chennai by eTravo. Ideal for employee transport, office pickup and drop, business travel, corporate commute, and professional fleet solutions with safe and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-chennai"
  }
};








    return (
        <div>
<Helmet>
  <title>Corporate Cab Services in Chennai | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services in Chennai with eTravo for employee transport, office pickup and drop, business travel, and corporate commute solutions. Safe and reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/158.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinchennai;